import React from "react";
import Slider from "react-slick";
import {  Typography, Box } from "@mui/material";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Carousel.css"; // Custom CSS file
import Card from "../Elements/Card/Card";

const cards = [
  {
    number: "1",
    title: "Recruitment and Staffing",
    points: [
      "Job Posting and Advertising: Creating job descriptions, posting job openings, and promoting them on various platforms.",
      "Talent Acquisition: Sourcing, screening, and selecting candidates.",
      "Interviewing: Conducting interviews and assessments.",
      "Onboarding: Managing the process for new employee orientation and integration into the company.",
    ],
  },
  {
    number: "2",
    title: "Employee Relations",
    points: [
      "Conflict Resolution: Mediating disputes between employees or between employees and management.",
      "Employee Engagement: Developing strategies to increase job satisfaction, morale, and productivity.",
      "Policy Development: Creating and communicating company policies, procedures, and guidelines.",
      "Employee Recognition: Designing and managing recognition programs for employees.",
    ],
  },
  {
    number: "3",
    title: "Compensation and Benefits",
    points: [
      "Payroll Management: Ensuring timely and accurate payment of wages, bonuses, and incentives.",
      "Benefit Administration: Managing employee benefits programs like health insurance, retirement plans, and perks.",
      "Compensation Strategy: Developing salary structures, compensation reviews, and bonuses.",
    ],
  },
  {
    number: "4",
    title: "Training and Development",
    points: [
      "Learning and Development Programs: Offering workshops, seminars, and courses to improve employee skills.",
      "Career Development: Providing guidance and resources for employee career growth.",
      "Leadership Training: Preparing employees for leadership roles through training programs.",
    ],
  },
  {
    number: "5",
    title: "Compensation and Benefits",
    points: [
      "Labor Law Compliance: Ensuring adherence to employment laws and regulations.",
      "Health and Safety: Ensuring a safe working environment and managing occupational health and safety standards.",
      "Diversity and Inclusion: Implementing and monitoring programs that promote workplace diversity.",
    ],
  },
  
  {
    number: "6",
    title: "Performance Management",
    points: [
      "Performance Appraisals: Developing systems for evaluating employee performance.",
      "Goal Setting: Helping employees set and track performance goals.",
      "Feedback Systems: Implementing 360-degree feedback and other mechanisms for performance improvement.",
    ],
  },
  
  {
    number: "7",
    title: "Workforce Planning and Strategy",
    points: [
      "Succession Planning: Developing strategies for future leadership roles and employee growth.",
      "Organizational Development: Structuring the organization for optimum performance.",
      "Workforce Analysis: Assessing workforce data to inform strategic decision-making.",
    ],
  },
  {
    number: "8",
    title: "Employee Wellness and Support",
    points: [
      "Employee Assistance Programs (EAP): Offering support for personal issues, counseling, and mental health resources.",
      "Wellness Programs: Promoting employee health through fitness programs, stress management, and well-being initiatives.",
      "Work-life Balance: Policies that allow employees to balance their work and personal life effectively.",
    ],
  },
 
  {
    number: "9",
    title: "HR Technology and Analytics",
    points: [
      "HR Software Implementation: Selecting and managing HR systemsfor payroll, recruitment, performance management, etc.",
      "HR Analytics: Using data to improve HR decision-making, such as turnover rates, employee engagement, and hiring patterns.",
    ],
  },
  {
    number: "10",
    title: "Outsourcing HR Functions",
    points: [
      "HR Consulting: Outsourcing HR advice or consulting for specific projects or ongoing management.",
      "Payroll Outsourcing: Using external providers to manage payroll processing and tax filings.",
      "Temporary Staffing: Managing temporary or contract workers on behalf of companies.",
    ],
  },
];

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3, // Show 3 cards in a row
  // slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 2, slidesToScroll: 1 },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 1, slidesToScroll: 1 },
    },
  ],
};

const ServiceCarousel = () => {
  return (
    
    <>
    <Box className="serviceCarousel" >
      <Slider {...settings} className="sider" >
        {cards.map((card, index) => (
          <Card key={index} className="carousel-card" >
            <Box display={"flex"} gap={2}>
            <Box className="step-number">{card.number} </Box>
            <Typography className="card-title-carogel" mb={"15px"}>{card.title}</Typography>
            </Box>
            <ul className="card-list">
  {card.points.map((point, i) => {
    const [boldText, ...rest] = point.split(":"); // Split karein ":" ke basis pe
    return (
      <li key={i}>
        <span style={{ fontWeight: 600 }} className="card-list-text">{boldText}:</span> {/* Thoda bold */}
        <span style={{ fontWeight: 400 }} className="card-list-text"> {rest.join(":")}</span> {/* Normal */}
      </li>
    );
  })}
</ul>

          </Card>
        ))}
      </Slider>
    </Box>
    </>
  );
};

export default ServiceCarousel;
